import { useLanguage } from "../../context/LanguageProvider";

export function LangToggle({ variant = "solid" }) {
    const { lang, setLang } = useLanguage();
    const isFr = lang === "fr";
    const baseBtn =
        "px-2 py-1 text-xs font-medium tracking-widest uppercase transition-colors duration-200";
    const activeCls = "text-gold";
    const idleCls = "text-neutral-400 hover:text-neutral-200";
    return (
        <div
            className={`inline-flex items-center gap-1 border ${
                variant === "outline"
                    ? "border-ink-borderStrong"
                    : "border-ink-border"
            } rounded-sm`}
            data-testid="lang-toggle"
            role="group"
            aria-label="Language selector"
        >
            <button
                type="button"
                data-testid="lang-toggle-fr"
                aria-pressed={isFr}
                onClick={() => setLang("fr")}
                className={`${baseBtn} ${isFr ? activeCls : idleCls}`}
            >
                FR
            </button>
            <span className="text-ink-borderStrong" aria-hidden="true">
                |
            </span>
            <button
                type="button"
                data-testid="lang-toggle-en"
                aria-pressed={!isFr}
                onClick={() => setLang("en")}
                className={`${baseBtn} ${!isFr ? activeCls : idleCls}`}
            >
                EN
            </button>
        </div>
    );
}
